import { BaseConfig } from './base-config.interface';
import { base } from './base';

export const environment: BaseConfig = {
  ...base,
  production: true,
  apiBaseUrl: 'https://entreprise.ws-preprod.mutlab.fr',
};
